import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Typography, Popconfirm, message } from 'antd';
import type { TableProps } from 'antd';
import moment from 'moment';
import SPButton from 'components/carRental/base/SPButton';

import emiter, {
  EVENT_CARRENTAL_STORE_DAY_OFF,
  EVENT_CARRENTAL_ADD_REST_DAY,
  EVENT_CARRENTAL_UPDATE_DAY_OFF_LIST
} from '../../../../events';

import { getRestScheduleList, restScheduleUpdateStatus } from 'hooks/carRental/store';

const { Text } = Typography;

const HandlerActionBar = (props: any) => {
  const { record, permission, updateList } = props || {};
  const text = record?.status === 1 ? '设为无效' : '设为有效';
  const handleInvalidSet = (code: number) => {
    restScheduleUpdateStatus({
      rest_schedule_code: code
    }).then((res: any) => {
      const { errno } = res || {};
      if (errno === 0) {
        message.success('操作成功');
        updateList && updateList();
      }
    });
  }
  return (
    <Popconfirm
      title={`确定将该休息日${text}吗`}
      onConfirm={() => handleInvalidSet(record?.rest_schedule_code)}
      okText="确定"
      cancelText="取消"
    >
      <SPButton permission={permission} type="link" permissionKey='store_rest_schedule_update_status'>{text}</SPButton>
    </Popconfirm>
  )
}

interface PropsType {
  enums?: any;
  permission?: any;
}

const DEFAULT_PAGE_SIZE = 5;

const SPRestDayManageModal: React.FC<PropsType> = (props) => {
  const { permission } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dayoffList, setDayoffList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPageData, setCurrentPageData] = useState<any>({ pageIndex: 1, pageSize: DEFAULT_PAGE_SIZE });
  const [storeInfo, setStoreInfo] = useState<any>({});

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleModelOpen = (data: any) => {
    showModal();
    setStoreInfo(data);
  }

  const handleRestDayAdd = () => {
    emiter.emit(EVENT_CARRENTAL_ADD_REST_DAY, storeInfo);
  }

  const StatusActionBar = (props: any) => (<>{`${props?.status === 1 ? '有效' : '无效' }`}</>);

  const TimeActionBar = (props: any) => <>{moment(props?.time * 1000).format('YYYY-MM-DD HH:mm')}</>;

  const TimeRangeActionBar = (props: any) => (<>{moment(props?.startTime * 1000).format('YYYY-MM-DD HH:mm')}-{moment(props?.endTime * 1000).format('YYYY-MM-DD HH:mm')}</>);



  const columns: TableProps<any>['columns'] = [
    {
      title: '休息日',
      key: 'name',
      render: (_, record) => <TimeRangeActionBar startTime={record.start_time} endTime={record.end_time} />
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      render: (time) => <TimeActionBar time={time} />
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => <StatusActionBar status={status} />,
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <HandlerActionBar record={record} permission={permission} updateList={() => getDayList(currentPageData)} />
      ),
    },
  ];

  const onPaginationChange = (data: any) => {
    const { current, pageSize } = data || {};
    const pageInfo = { pageIndex: current, pageSize };
    setCurrentPageData(pageInfo);
    getDayList(pageInfo);
  }

  const getDayList = (data: any) => {
    const { pageIndex, pageSize, code } = data || {};
    setCurrentPageData({pageIndex: pageIndex || 1, pageSize: pageSize || DEFAULT_PAGE_SIZE});
    getRestScheduleList({
      page: pageIndex,
      page_size :pageSize,
      store_code: code || storeInfo?.store_code,
    }).then((res: any) => {
      const { data } = res || {};
      const { list, total } = data || {};
      setDayoffList(list);
      setTotalCount(total);
    });
  }

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_STORE_DAY_OFF, handleModelOpen);
    emiter.on(EVENT_CARRENTAL_UPDATE_DAY_OFF_LIST, (code) => getDayList({
      pageIndex: 1,
      pageSize: currentPageData?.pageSize,
      code,
    }));
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_STORE_DAY_OFF)
      emiter.removeAllListeners(EVENT_CARRENTAL_UPDATE_DAY_OFF_LIST)
    }
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      getDayList({
        pageIndex: 1,
        pageSize: DEFAULT_PAGE_SIZE,
      })
    }
  }, [isModalOpen]);


  return (
    <Modal
      title="门店休息日列表"
      width={800}
      open={isModalOpen}
      onOk={handleCancel}
      onCancel={handleCancel}
      okText="关闭"
      cancelButtonProps={{style: { display: 'none' }}}
    >
      <SPButton permission={permission} permissionKey='store_rest_schedule_add' type="primary" style={{ marginBottom: '8px' }} onClick={handleRestDayAdd}>新增休息日</SPButton>
      <Text type="secondary" style={{ marginBottom: '12px', display: 'block' }}>休息日目前无需审核</Text>
      <Table
        columns={columns}
        dataSource={dayoffList}
        rowKey={row => row.id}
        pagination={{
          total: totalCount,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal:total => `共 ${total} 条数据`,
          current:currentPageData?.pageIndex,
          pageSize:currentPageData?.pageSize,
          pageSizeOptions: [5, 10, 20, 50, 100]
        }}
        onChange={onPaginationChange}
      />
    </Modal>
  )
}

export default SPRestDayManageModal;
